<template lang="pug">
section.ticket(:class="{'returned': ticket.returnedAt && ticket.returnedAt.length}")
  .ticket__left
    picture.ticket__image
      //- img(:src="ticket.performance.image['170x240']")
      ticket-icon-big(:type="'train'")
      // 100x140

    .ticket__qr(v-if="!ticket.returnedAt")
      // 100x100
      qr-code-vue(:value="ticket.code" :size="80" level="H")
    .er-status(v-if="ticket.remoteCheckIn")
      .mark электронная регистрация включена
    .er-status.no-er(v-else)
      .mark электронная регистрация не включена

  .ticket__right
    .ticket__tag Ж/Д билеты
    .ticket__tag.ticket__tag-canceled(v-if="ticket.returnedAt && ticket.returnedAt.length") Отменен
    .ticket__title {{ticket.from}} - {{ticket.to}}
    .ticket__table
      .ticket__table-line
        | Дата и время отправления:
        | &nbsp;<span>{{ ticket.date }}, {{ticket.departureTimeInformation}}</span>
      .ticket__table-line Код: <span>{{ticket.code}}</span>
      .ticket__table-line Перевозчик: <span>{{ticket.carrierName}}</span>
      .ticket__table-line Номер поезда: <span>{{ ticket.trainNumber }}</span>
      .ticket__table-line ФИО: <span>{{ ticket.fio }}</span>
      .ticket__table-line Вагон: <span>{{ ticket.carNumber }}</span>
      .ticket__table-line Место: <span>{{ ticket.places }}</span>
      .ticket__table-line(v-if="ticket.additionalTerms")
        | Дополнительная информация: <span>{{ ticket.additionalTerms }}</span>
      .ticket__table-line Стоимость: <span>{{ ticket.price | price }} руб.</span>
      .ticket__table-line Справочно-информационные услуги:
        | &nbsp;<span>{{ ticket.commission | price }} руб.</span>
    .ticket__price Итого: {{ (ticket.price + ticket.commission) | price }} руб.
    .ticket__footer
      template(v-if="ticket.remoteCheckInAvailable && !ticket.returnedAt && !isUsed && !noOp")
        arc-button(v-if="ticket.remoteCheckIn", name="Отменить электронную регистрацию",
        @click="removeEReg = true" outline-gray)
        arc-button(v-else,
        name="Электронная регистрация", @click="addEReg = true",
        outline-gray)
      arc-button(v-if="!noOp", name="Распечатать",
        @click="doAction({action: 'print'})", outline-gray)
      arc-drop-button(name="Еще", top, :list="more",
        @action="doAction", outline-gray)

  popup-return(v-if="showReturn", :orderId="orderId", :ticket="ticket", :type="'trains'",
    @close="showReturn = false", @onReturn="update()")

  popup-cancel(v-if="showCancel", :orderId="orderId", :ticketId="ticket.id", :type="'trains'",
    @close="showCancel = false", @onCancel="update()")

  popup-er(v-if="removeEReg",
    :orderId="orderId",
    :ticketId="ticket.id",
    :type="'ticket'",
    :status="0",
    @close="removeEReg = false",
    @onCancel="update()")

  popup-er(v-if="addEReg",
    :orderId="orderId",
    :ticketId="ticket.id",
    :type="'ticket'",
    :status="1",
    @close="addEReg = false",
    @onCancel="update()")

</template>

<script>
import QrCodeVue from 'qrcode.vue';
import cfg from '@/api/config';

import popupReturn from '@/components/popups/return.vue';
import popupCancel from '@/components/popups/cancel.vue';
import popupEr from '@/components/popups/EReg.vue';

import TicketIcon from '../icon/icon';
import TicketIconBig from '../icon/big-icon';

export default {
  name: '',
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    orderId: {
      type: Number,
      required: true,
    },
    isUsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    noOp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    showReturn: false,
    showCancel: false,
    addEReg: false,
    removeEReg: false,
    more: [],
  }),
  computed: {
    cabinet() {
      if (this.$store.state.cabinet) {
        return this.$store.state.cabinet;
      }
      return null;
    },
  },
  mounted() {
    this.makeMore();
    console.log('isUsed', this.isUsed);
  },
  methods: {
    update() {
      this.$emit('update');
      this.showReturn = false;
      this.showCancel = false;
      this.addEReg = false;
      this.removeEReg = false;
    },
    makeMore() {
      if (!this.noOp) {
        if (!this.ticket.code && !this.ticket.returnedAt && !this.isUsed) {
          this.more.push({
            action: 'cancel', name: 'Отменить',
          });
        }
        if (this.ticket.code && !this.ticket.returnedAt && !this.isUsed) {
          this.more.push({
            action: 'return', name: 'Возврат',
          });
        }
        this.more.push({
          action: 'reciept', name: 'Чек оплаты',
        });
        if (this.ticket.returnedAt && this.ticket.returnedAt.length) {
          this.more.push({
            action: 'reciept-return', name: 'Чек возврата',
          });
        }
      }
    },
    doAction(params) {
      if (params.action === 'cancel') {
        this.showCancel = true;
      } else if (params.action === 'return') {
        this.showReturn = true;
      } else if (params.action === 'print') {
        const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
        if (!downloadToken) {
          return;
        }
        window.open(`${cfg.baseUrl}/api/v3/order/${this.orderId}/trains/${this.ticket.id}/pdf?t=${downloadToken}`);
      } else if (params.action === 'reciept') {
        const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
        if (!downloadToken) {
          return;
        }
        window.open(`${cfg.baseUrl}/api/v3/order/${this.orderId}/trains/${this.ticket.id}/receipt?t=${downloadToken}`);
      } else if (params.action === 'reciept-return') {
        const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
        if (!downloadToken) {
          return;
        }
        window.open(`${cfg.baseUrl}/api/v3/order/${this.orderId}/trains/${this.ticket.id}/receipt?t=${downloadToken}&returned=1`);
      }
    },
  },
  components: {
    QrCodeVue,
    TicketIcon,
    TicketIconBig,
    popupReturn,
    popupCancel,
    popupEr,
  },
};
</script>

<style lang="scss"></style>
